import React from 'react'
import styled from 'styled-components'
import { colors } from '../styles/globals'
import { Tooltip } from 'antd'

interface Props {
  url?: string
  icon?: string
  class?: string
  id?: string
  className?: string
  method?: string
  tooltip?: string
}

const Icon = (props: Props): JSX.Element => {
  // Need some javascript to click on the link via post method
  const submitPost = () => {
    if (props.url)
      (document.getElementById(props.url) as HTMLFormElement).submit()
  }

  const auth_token = (
    document.querySelector('meta[name="csrf-token"]') as HTMLFormElement
  ).content

  return (
    <Wrapper>
      <Tooltip title={props.tooltip} placement="bottom" color="#1576E1">
        <form id={props.url} action={props.url} method={props.method || 'get'}>
          <div onClick={() => submitPost()}>
            {props.icon ? (
              <IconImg
                id={props.id}
                className={props.className}
                icon={props.icon}
              />
            ) : (
              <IconI
                id={props.id}
                class={props.class}
                className={props.className}
              />
            )}
          </div>
          <input type="hidden" name="authenticity_token" value={auth_token} />
        </form>
      </Tooltip>
    </Wrapper>
  )
}

const IconImg = (props: Props): JSX.Element => (
  <img src={props.icon} id={props.id} className={props.className} />
)

const IconI = (props: Props): JSX.Element => <i className={props.className} />

const Wrapper = styled.a`
  display: inline-flex;
  margin: 10px 5px 10px 0px;
  align-items: center;
  justify-content: center;
  color: #1576e1;
  height: 33px;
  width: 33px;
  border: 1px ${colors.lightBlue} solid;
  background-color: white;
  border-radius: 50%;
`

export default Icon
